import { Box } from '@chakra-ui/react';
import useImagesViewer from './ImagesViewerContainer';
import ToolBar from './ToolBar';
import VirtualList from './VirtualList';

const ImagesViewer = ({ readonly }: { readonly: boolean }) => {
    const props = useImagesViewer({ readonly });
    const { imageList, isFetching } = props;

    return (
        <Box mt={6}>
            <ToolBar {...props} />
            <VirtualList items={imageList} isLoading={isFetching} readonly={readonly} />
        </Box>
    );
};

export default ImagesViewer;
